import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import { Text } from "../../Typography";
import styles from './Breadcrumbs.scss';

var BreadcrumbsItem = function BreadcrumbsItem(_ref) {
  var children = _ref.children,
      seporator = _ref.seporator;
  return /*#__PURE__*/React.createElement("li", {
    className: classnames(styles.item, _defineProperty({}, styles.separator, seporator))
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    size: "small",
    color: "label"
  }, children));
};

var Breadcrumbs = function Breadcrumbs(_ref2) {
  var children = _ref2.children,
      _ref2$ariaLabel = _ref2.ariaLabel,
      ariaLabel = _ref2$ariaLabel === void 0 ? 'breadcrumb' : _ref2$ariaLabel,
      className = _ref2.className,
      linkBack = _ref2.linkBack,
      linkHome = _ref2.linkHome;
  var items = React.Children.toArray(children).filter(Boolean);
  return /*#__PURE__*/React.createElement(React.Fragment, null, linkBack, /*#__PURE__*/React.createElement("nav", {
    "aria-label": ariaLabel,
    className: classnames(styles.breadcrumbs, className)
  }, /*#__PURE__*/React.createElement("ul", {
    className: styles.items
  }, !!linkHome && /*#__PURE__*/React.createElement(BreadcrumbsItem, {
    seporator: items.length > 0
  }, linkHome), items.map(function (child, index) {
    return /*#__PURE__*/React.createElement(BreadcrumbsItem, {
      key: String(index),
      seporator: items.length > 1 && index < items.length - 1
    }, child);
  }))));
};

export default Breadcrumbs;